<template>
  <div class="complaint-type-container">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('complaintType.title') }}</span>
        <el-button type="primary" size="small" style="float: right;" @click="_openAddComplaintTypeModal">
          {{ $t('complaintType.add') }}
        </el-button>
      </div>

      <el-table :data="complaintTypeInfo.complaintTypes" border style="width: 100%" v-loading="loading">
        <el-table-column prop="typeName" :label="$t('complaintType.typeName')" align="center" />
        <el-table-column prop="notifyWay" :label="$t('complaintType.notifyWay')" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.notifyWay === 'SMS'">
              {{ $t('complaintType.sms') }}
            </span>
            <span v-else-if="scope.row.notifyWay === 'WORK_LICENSE'">
              {{ $t('complaintType.wechatWorkLicense') }}
            </span>
            <span v-else>
              {{ $t('complaintType.wechat') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="appraiseReply" :label="$t('complaintType.appraiseReply')" align="center">
          <template slot-scope="scope">
            {{ scope.row.appraiseReply === 'Y' ? $t('complaintType.autoReply') : $t('complaintType.manualReply') }}
          </template>
        </el-table-column>
        <el-table-column prop="staffs" :label="$t('complaintType.handler')" align="center">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.staffs" :key="index">
              {{ item.staffName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('complaintType.seq')" align="center" width="70">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('complaintType.createTime')" align="center" />
        <el-table-column :label="$t('common.operation')" align="center" width="330">
          <template slot-scope="scope">
            <el-button size="mini" type="text" icon="el-icon-top" :disabled="scope.$index === 0"
              @click="_moveComplaintType(scope.row, -1)">
              {{ $t('complaintType.moveUp') }}
            </el-button>
            <el-button size="mini" type="text" icon="el-icon-bottom"
              :disabled="scope.$index === complaintTypeInfo.complaintTypes.length - 1"
              @click="_moveComplaintType(scope.row, 1)">
              {{ $t('complaintType.moveDown') }}
            </el-button>
            <el-button size="mini" type="primary" @click="_openEditComplaintTypeModel(scope.row)">
              {{ $t('common.edit') }}
            </el-button>
            <el-button size="mini" type="danger" @click="_openDeleteComplaintTypeModel(scope.row)">
              {{ $t('common.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <delete-complaint-type ref="deleteComplaintType" @success="handleSuccess" />
  </div>
</template>

<script>
import { listComplaintType, updateComplaintTypeSeq } from '@/api/oa/complaintTypeApi'
import DeleteComplaintType from '@/components/oa/deleteComplaintType'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'ComplaintTypeList',
  components: {
    DeleteComplaintType
  },
  data() {
    return {
      loading: false,
      complaintTypeInfo: {
        complaintTypes: [],
        total: 0,
        conditions: {
          typeCd: '',
          typeName: '',
          notifyWay: ''
        }
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this._listComplaintTypes()
  },
  methods: {
    async _listComplaintTypes() {
      try {
        this.loading = true
        const params = {
          // 类型数量级小（单小区几十个），全量加载以便整体排序操作
          page: 1,
          row: 999,
          communityId: this.communityId,
          ...this.complaintTypeInfo.conditions
        }
        const { data, total } = await listComplaintType(params)
        this.complaintTypeInfo.complaintTypes = data
        this.complaintTypeInfo.total = total
      } catch (error) {
        this.$message.error(this.$t('complaintType.fetchError'))
      } finally {
        this.loading = false
      }
    },
    // 上移/下移：与相邻行交换排序号，一次请求批量原子提交
    async _moveComplaintType(complaintType, offset) {
      const list = this.complaintTypeInfo.complaintTypes
      const index = list.findIndex(item => item.typeCd === complaintType.typeCd)
      const neighbor = list[index + offset]
      if (index < 0 || !neighbor) {
        return
      }
      try {
        const res = await updateComplaintTypeSeq({
          seqItems: [
            { typeCd: complaintType.typeCd, seq: neighbor.seq },
            { typeCd: neighbor.typeCd, seq: complaintType.seq }
          ]
        })
        if (res.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this._listComplaintTypes()
        } else {
          this.$message.error(res.msg || this.$t('complaintType.moveDisabledTip'))
        }
      } catch (error) {
        this.$message.error(this.$t('complaintType.moveDisabledTip'))
      }
    },
    _openAddComplaintTypeModal() {
      this.$router.push('/views/oa/addComplaintType')
    },
    _openEditComplaintTypeModel(complaintType) {
      this.$router.push(`/views/oa/editComplaintType?typeCd=${complaintType.typeCd}`)
    },
    _openDeleteComplaintTypeModel(complaintType) {
      this.$refs.deleteComplaintType.open(complaintType)
    },
    handleSuccess() {
      this._listComplaintTypes()
    }
  }
}
</script>

<style lang="scss" scoped>
.complaint-type-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>